export type PostingFilter = 'all' | 'posted' | 'unposted';
export type SourceTypeFilter = 'all' | 'bank' | 'cashbox';

export function parseIsoDate(value: string, endOfDay = false): Date | null {
  if (!value?.trim()) {
    return null;
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return null;
  }

  if (endOfDay) {
    parsed.setHours(23, 59, 59, 999);
  }

  return parsed;
}

export function matchesDateRange(documentDateUtc: string | undefined, start: Date | null, end: Date | null): boolean {
  if (!start && !end) {
    return true;
  }

  if (!documentDateUtc) {
    return false;
  }

  const date = new Date(documentDateUtc);
  if (Number.isNaN(date.getTime())) {
    return false;
  }

  if (start && date < start) {
    return false;
  }

  if (end && date > end) {
    return false;
  }

  return true;
}

export function matchesText(value: string | undefined, term: string): boolean {
  if (!term.trim()) {
    return true;
  }

  return (value ?? '').toLowerCase().includes(term.trim().toLowerCase());
}

export function matchesAmountRange(amount: number, min: number | null, max: number | null): boolean {
  if (min !== null && min !== undefined && !Number.isNaN(min) && amount < min) {
    return false;
  }

  if (max !== null && max !== undefined && !Number.isNaN(max) && amount > max) {
    return false;
  }

  return true;
}

export function matchesPostingFilter(journalEntryId: string | undefined, filter: PostingFilter): boolean {
  if (filter === 'all') {
    return true;
  }

  const posted = Boolean(journalEntryId?.trim());
  return filter === 'posted' ? posted : !posted;
}

export function sumAmount<T extends { amount: number }>(rows: readonly T[]): number {
  return rows.reduce((total, row) => total + row.amount, 0);
}
